import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import * as urlParser from 'url-parse';
import * as qs from 'qs';
import moment from 'moment';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { ApiHelperV2 } from '../common/helpers/ApiHelperV2';
import { Helper } from '../common/helpers/Helper';
import { Controller } from '../common/Controller';
import { AppConfig } from '../AppConfig';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { CommonStyles } from '../styles/Styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { AppTheme } from '../styles/AppTheme';
import { AppHelper } from '../helpers/AppHelper'
import Slider, { Range } from 'rc-slider';
import 'rc-slider/assets/index.css';

export class ClientPlaceCamsDetails extends Component {
  constructor(props) {
    super(props);
    this.slug = this.props.match.params.id ? this.props.match.params.id : null;
    this.imageFeedRefreshInterval = AppConfig.imageFeedRefreshInterval;
    this.updateItemsInterval = AppConfig.eventRefreshInterval;
    this.updateImageIntervalFnId = null;
    this.updateItemsIntervalFnId = null;
    this.alertRaisedByCamId = {};
    this.orgId = Controller.get().userMgrV2().getOrgId()
    this.fields = {
      selectedPlace: {
        key: 'selectedPlaceId',
        label: 'Place',
        type: 'text'
      }
    }
    this.state = {
      canPlayVideo: true,
      videoLoadErrHandler: false,
      selectedPlaceId: this.slug ? this.slug : null,
      fetchState: ApiHelperV2.State.LOADING,
      fullScreenMode: Controller.get().userMgrV2().getFullScreenMode() ? 'Full Screen Mode ON' : 'Full Screen Mode OFF',
      fullScreenModeValue: Controller.get().userMgrV2().getFullScreenMode() ? true : false,
      colNumber: 4,
    }
  }

  componentDidMount() {
    this.fetchItems();
    this.updateImageIntervalFnId = setInterval(() => {
      //console.log("updating live image...")
      this.updateImageFeedUrl();
    }, this.imageFeedRefreshInterval);

    this.updateItemsIntervalFnId = setInterval(() => {
      this.refresh();
    }, this.updateItemsInterval);
  }

  refresh() {
    this.fetchItems()
  }

  componentWillUnmount() {
    if (this.updateImageIntervalFnId) {
      clearInterval(this.updateImageIntervalFnId);
    }
    if (this.updateItemsIntervalFnId) {
      clearInterval(this.updateItemsIntervalFnId);
    }
  }

  updateImageFeedUrl() {
    const clientCamsDetails = this.state.clientCamsDetails
    if (clientCamsDetails && clientCamsDetails.cams) {
      this.setState({
        clientCamsDetails: this.attachTsToURL(clientCamsDetails)
      })
    }
  }

  fetchItems() {
    /*this.setState({
      fetchState: ApiHelperV2.State.LOADING
    })*/
    ApiHelperV2.call(
      { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['placesByOrgId'], { orgId: this.orgId }) },
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        if (Object.keys(this.alertRaisedByCamId).length === 0) {
          if (results && results.length > 1) {
            for (const r of results) {
              for (const c of r.cams) {
                this.alertRaisedByCamId[c._id] = false
              }
            }
          }
        }


        if (results && results.length > 1) {
          let allCams = [];
          for (const r of results) {
            if (r.cams && r.cams.length > 0) {
              allCams = allCams.concat(r.cams)
            }
          }
          results.push({
            _id: 'all',
            name: 'All',
            cams: allCams
          })
        }


        for (const r of results) {
          if (r._id === this.slug) {
            this.setState({
              clientCamsDetails: this.attachTsToURL(r),
              selectedPlaceId: r._id
            })
            break;
          }
        }

        this.setState({
          items: results,
          fetchState: ApiHelperV2.State.READY
        })
      }.bind(this))
  }

  attachTsToURL = (item) => {
    if (item.cams) {
      for (const cam of item.cams) {
        const urlParsed = new urlParser(cam.urlJpeg);
        const currQueryString = (urlParsed.query).substring(1);
        const queryParams = qs.parse(currQueryString);
        queryParams.timestamp = moment().valueOf();
        const modifiedQueryString = qs.stringify(queryParams);
        cam.urlJpeg = urlParsed.origin + urlParsed.pathname + '?' + modifiedQueryString;
      }
    }
    return item;
  }

  loadVideo = (item) => {
    document.getElementById(item._id).load();
  }

  videoLoadErrHandler = () => {
    this.setState({ videoLoadErrHandler: true })
  }

  canPlayVideo = () => {
    //console.log('canPlayVideo True')
    this.setState({ canPlayVideo: true })
  }

  onSelect = event => {
    for (const item of this.state.items) {
      if (item._id === event.target.value) {
        this.setState({
          [event.target.name]: event.target.value,
          clientCamsDetails: item,
        });
        this.slug = item._id
        this.props.history.replace('/places/' + item._id + '/cams/')
        break;
      }
    }
  };

  generateSelectField = (formField, data) => {
    return (
      <div className={css(Styles.selectInnerContainer)}>
        <FormControl className={css(Styles.selectInnerContainer)}>
          <InputLabel>{formField.label}</InputLabel>
          <Select
            name={formField.key}
            value={this.state[formField.key]}
            onChange={this.onSelect}
          >
            {data.map(item => {
              return (
                <MenuItem value={item._id}>{item.name}</MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </div>
    )
  }

  getPlaceName = (cam) => {
    for (const item of this.state.items) {
      if (item._id === cam.placeId) {
        return item.name
      }
    }
  }

  isNewEvent = (item) => {
    const audio = new Audio(require('../assets/audio/alert.mp3'));
    if (!item.lastSeenTs) {
      if (!this.alertRaisedByCamId[item._id] && item.latestEventPriority === 3) {
        if (AppConfig.eventNotificationSound) {
          audio.play()
        }
      }
      this.alertRaisedByCamId[item._id] = true
      return true
    }
    if (item.latestEventTs && item.lastSeenTs) {
      if (moment(item.latestEventTs).valueOf() > moment(item.lastSeenTs).valueOf()) {
        if (!this.alertRaisedByCamId[item._id] && item.latestEventPriority === 3) {
          if (AppConfig.eventNotificationSound) {
            audio.play()
          }
        }
        this.alertRaisedByCamId[item._id] = true
        return true
      }
    }
    this.alertRaisedByCamId[item._id] = false
    return false
  }

  getVideoView = (item) => {
    const colNum = 12 / AppConfig.allCamViewNumberOfColumns;
    return (
      <Grid item xs={colNum} sm={colNum}>
        <Link
          target='_blank'
          to={{ pathname: '/places/' + item.placeId, search: '?camId=' + item._id + '&showlive=true' }}
          className={css(Styles.link)}>
          <div className={css(Styles.eventContainer)}>
            <div className={css(Styles.eventContainerHeader)}>
              <Icon className={css(Styles.camIcon)} color='secondary'>
                videocam
              </Icon>
              <p className={css(Styles.headerContainerEvent)}>{item.name}</p>
              <div className={css(Styles.refreshContainer)}>
                <Icon className={css(Styles.refreshIcon)} color='secondary' onClick={e => this.loadVideo(item)}>
                  loop
                </Icon>
              </div>
            </div>
            <div className={css(Styles.latestEventContainerImg)}>
              {this.state.videoLoadErrHandler &&
                <p className={css(Styles.errorMSg)}>Failed to load the video</p>
              }
              {!this.state.canPlayVideo &&
                <CircularProgress className={css(Styles.progress)} />
              }
              {!this.state.videoLoadErrHandler && this.state.canPlayVideo &&
                <video
                  style={{ maxWidth: '100%', maxHeight: '100%' }}
                  videoPlayer
                  id={item._id}
                  src={item.urlVideo}
                  //src={require('../assets/video.mp4')}
                  type='video/mp4'
                  controls
                  autoplay='autoplay'
                  controlsList='nodownload'
                  error={this.videoLoadErrHandler}
                  canplay={this.canPlayVideo}>
                </video>
              }
            </div>
          </div>
        </Link>
      </Grid>
    )
  }

  getImageView = (item) => {
    const colNum = 12 / AppConfig.allCamViewNumberOfColumns;
    return (
      <Grid item xs={this.state.colNumber} sm={this.state.colNumber}>
        <Link
          target='_blank'
          to={{ pathname: '/places/' + item.placeId, search: '?camId=' + item._id + '&showlive=true' }}
          className={css(Styles.link)}>
          <div className={css(Styles.eventContainer)}>
            <div className={css(Styles.eventContainerHeader)}>
              <Icon className={css(Styles.camIcon)} color='secondary'>
                videocam
              </Icon>
              <p className={css(Styles.headerContainerEvent)}>{item.name}</p>
              {this.state.selectedPlaceId === 'all' &&
                <p className={css(Styles.headerContainePlace)}>{this.getPlaceName(item)}</p>
              }
              {this.isNewEvent(item) &&
                <div>
                  <div className={css(Styles.pulse)} style={{ background: AppHelper.getPriotiyColor(item.latestEventPriority) }}></div>
                </div>
              }
            </div>
            <div className={css(Styles.latestEventContainerImg)}>
              <img
                style={{ width: '100%' }}
                src={item.urlJpeg}
                alt='Live Image Stream'
                className={css(Styles.eventContainerImgLive)}
              />
            </div>
          </div>
        </Link>
      </Grid>
    )
  }

  fullScreenModeValueFun = name => event => {
    this.setState({ [name]: event.target.checked });
    if (event.target.checked) {
      this.setState({ fullScreenMode: 'Full Screen Mode ON' })
      Controller.get().userMgrV2().setFullScreenMode(true)
    } else {
      this.setState({ fullScreenMode: 'Full Screen Mode OFF' })
      Controller.get().userMgrV2().setFullScreenMode(false)
    }
    window.location.reload();
  };

  sliderFunction = (e) => {
    let value = 0;
    if (e === 0) {
      value = 12
    } else if (e === 1) {
      value = 6
    } else if (e === 2) {
      value = 4
    } else if (e === 3) {
      value = 3
    } else if (e === 4) {
      value = 2
    } else if (e === 5) {
      value = 1
    }
    this.setState({
      colNumber: value
    })
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  readyView = () => {
    return (
      <div className={css(CommonStyles.outerContainer)}>
        <div>
          <div className={css(Styles.headerOuterContainer)}>
            <Link to={{ pathname: '/places' }} className={css(CommonStyles.navLink)} >
              <Icon className={css(CommonStyles.navIcon)} color='secondary' >
                location_city
              </Icon>
              <p className={css(CommonStyles.navTitle)}>Places</p>
            </Link>
            {this.state.items.length > 1 ?
              this.state.clientCamsDetails &&
              this.generateSelectField(this.fields.selectedPlace, this.state.items) :
              <p className={css(Styles.placeName)}>{this.state.items[0].name}</p>
            }

            <div className={css(Styles.actionButtonContainer)}>
              <div className={css(Styles.SliderOuterContainer)}>
                <div className={css(Styles.sliderTitle)}>Grid View</div>
                <Slider
                  min={0}
                  max={5}
                  defaultValue={2}
                  step={1}
                  className={css(Styles.sliderContainer)}
                  railStyle={{ backgroundColor: '#000', height: 14, opacity: .38 }}
                  trackStyle={{ backgroundColor: AppTheme.secondaryColor, height: 14, opacity: 1 }}
                  handleStyle={{
                    borderColor: '#fafafa',
                    height: 21,
                    width: 21,
                    marginLeft: 0,
                    marginTop: -3,
                    backgroundColor: '#fafafa',
                    boxShadow: '0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.12)'
                  }}
                  onChange={this.sliderFunction}
                />
              </div>

              <FormControlLabel
                className={css(Styles.formControlLabelContainer)}
                control={
                  <Switch
                    checked={this.state.fullScreenModeValue}
                    onChange={this.fullScreenModeValueFun('fullScreenModeValue')}
                    value='fullScreenModeValue'
                  />
                }
                classes={{
                  label: css(Styles.formControlLabel),
                }}
                label={this.state.fullScreenMode}
              />
            </div>
          </div>
          <Grid spacing={8} container>
            {this.state.clientCamsDetails &&
              this.state.clientCamsDetails.cams.length > 0 ?
              this.state.clientCamsDetails.cams.map(item => {
                if (item.urlVideo && !item.urlJpeg) {
                  return this.getVideoView(item)
                } else if (item.urlJpeg) {
                  return this.getImageView(item)
                }
              })
              :
              <p className={css(Styles.emptyView)}>Cameras not installed at this place.</p>
            }
          </Grid>
        </div>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    width: '95%',
    paddingTop: 120,
    overflow: 'hidden'
  },
  headerOuterContainer: {
    display: 'flex',
    paddingBottom: 15,
    alignItems: 'center',
  },

  headerContainer: {
    fontSize: 25,
    fontWeight: 'bold'
  },
  headerContainerEvent: {
    fontSize: 15,
    fontWeight: 'bold',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingRight: 50,
    flex: 1,
  },
  headerContainePlace: {
    fontSize: 15,
    fontWeight: 'bold',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  eventContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: AppTheme.secondaryBg,
  },
  eventContainerHeader: {
    display: 'flex',
    padding: 10,
    alignItems: 'center'
  },
  refreshContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  refreshIcon: {
    borderRadius: '50%',
    color: 'white',
    backgroundColor: '#303E8A',
    padding: 5,
    fontSize: 25,
    cursor: 'pointer',
  },
  latestEventContainerImg: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'black',
    position: 'relative',
    alignItems: 'center',
  },
  errorMSg: {
    color: 'white',
    fontSize: 20
  },
  progress: {
    color: 'white',
    fontSize: 35
  },
  actionButtonContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  actionButton: {
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'bolder',
    margin: 0,
    fontSize: 16,
    textTransform: 'unset',
  },
  link: {
    textDecoration: 'none'
  },
  camIcon: {
    fontSize: 18,
    paddingRight: 10,
  },
  selectInnerContainer: {
    flex: .5,
    display: 'flex',
    color: 'black',
    fontSize: 18
  },
  emptyView: {
    paddingTop: 200,
    flex: 1,
    textAlign: 'center'
  },
  placeName: {
    marginTop: 5,
    marginBottom: 5,
    fontSize: 22,
    fontWeight: 'bold'
  },
  formControlLabelContainer: {
    width: 235,
    backgroundColor: 'whitesmoke'
  },
  formControlLabel: {
    fontWeight: 'bolder',
    fontSize: 17,
  },
  formBreak: {
    height: 30,
    borderRight: '2px solid grey',
    margin: 0,
    marginRight: 10,
    marginLeft: 10,
  },
  SliderOuterContainer: {
    backgroundColor: 'whitesmoke',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 4,
    paddingRight: 10,
    paddingLeft: 10,
    marginRight: 30,
  },
  sliderContainer: {
    width: 70,
    padding: 0
  },
  sliderTitle: {
    fontSize: 12,
    margin: 5,
  },
  pulse: {
    display: 'block',
    width: 18,
    height: 18,
    borderRadius: '50%',
    //background:'red',
    cursor: 'pointer',
    boxShadow: '0 0 0 rgba(255, 0, 0, 0.4)',
    animation: 'pulse 2s infinite',
    ':hover': {
      animation: 'none'
    }
  },
})



// WEBPACK FOOTER //
// ./src/screens/ClientPlaceCamsDetails.js